import React from 'react';
import { Link } from 'react-router-dom';

const Security = () => {
  return (
    <div className="container">
    <div className="row">
  
      {/* Two Factor Security */}
      <div className="col-12 mb-4">
        <div className="card">
          <div className="card-body row">
            <div className="col-12 col-md-9 col-xl-10">
              <h2 className="mb-2">Two factor security</h2>
              <p className="text-body-secondary mb-md-0">
                Two-factor authentication adds an additional layer of security to your account by requiring more than just a password to log in.
              </p>
            </div>
            <div className="col-12 col-md-auto mt-3 mt-md-0">
              <button className="btn btn-primary">Enable</button>
            </div>
          </div>
        </div>
      </div>
  
      {/* Auth Options */}
      <div className="col-12 mb-5">
        <div className="card">
          <div className="card-body">
            <div className="list-group list-group-flush my-n3">
  
              <div className="list-group-item">
                <div className="row align-items-center">
                  <div className="col">
                    <h4 className="mb-1">Authenticator app</h4>
                    <small className="text-body-secondary">Google auth or 1Password</small>
                  </div>
                  <div className="col-auto">
                    <Link to="/account/authenticator" className="btn btn-sm btn-white">Setup</Link>
                  </div>
                </div>
              </div>
  
              <div className="list-group-item">
                <div className="row align-items-center">
                  <div className="col">
                    <h4 className="mb-1">SMS Recovery</h4>
                    <small className="text-body-secondary">Standard messaging rates apply</small>
                  </div>
                  <div className="col-auto">
                    <button className="btn btn-sm btn-danger">Disable</button>
                  </div>
                </div>
              </div>
  
              <div className="list-group-item">
                <div className="row align-items-center">
                  <div className="col">
                    <h4 className="mb-1">Recovery codes</h4>
                    <small className="text-body-secondary">Standard messaging rates apply</small>
                  </div>
                  <div className="col-auto">
                    <button className="btn btn-sm btn-white">Reveal</button>
                  </div>
                </div>
              </div>
  
            </div>
          </div>
        </div>
      </div>
  
      {/* Password Change */}
      <div className="col-12">
        <hr className="my-5" />
        <div className="row justify-content-between align-items-center mb-5">
          <div className="col-12 col-md-9 col-xl-7">
            <h2 className="mb-2">Change your password</h2>
            <p className="text-body-secondary mb-xl-0">
              We will email you a confirmation when changing your password, so please expect that email after submitting.
            </p>
          </div>
          <div className="col-12 col-xl-auto mt-3 mt-xl-0">
            <button className="btn btn-white">Forgot your password?</button>
          </div>
        </div>
  
        <div className="row">
          <div className="col-12 col-md-6 order-md-2">
            <div className="card bg-light border ms-md-4">
              <div className="card-body">
                <p className="mb-2">Password requirements</p>
                <p className="small text-body-secondary mb-2">
                  To create a new password, you have to meet all of the following requirements:
                </p>
                <ul className="small text-body-secondary ps-4 mb-0">
                  <li>Minimum 8 characters</li>
                  <li>At least one special character</li>
                  <li>At least one number</li>
                  <li>Can’t be the same as a previous password</li>
                </ul>
              </div>
            </div>
          </div>
  
          <div className="col-12 col-md-6">
            <form>
              <div className="form-group">
                <label className="form-label">Current password</label>
                <input type="password" className="form-control" />
              </div>
              <div className="form-group">
                <label className="form-label">New password</label>
                <input type="password" className="form-control" />
              </div>
              <div className="form-group">
                <label className="form-label">Confirm new password</label>
                <input type="password" className="form-control" />
              </div>
              <button className="btn w-100 btn-primary lift" type="submit">Update password</button>
            </form>
          </div>
        </div>
      </div>
  
      {/* Device History */}
      <div className="col-12 mt-5">
        <hr className="my-5" />
        <div className="row justify-content-between align-items-center mb-5">
          <div className="col-12 col-md-9 col-xl-7">
            <h2 className="mb-2">Device History</h2>
            <p className="text-body-secondary mb-xl-0">
              If you see a device here that you believe wasn’t you, please contact our account <a href="#!">fraud department</a> immediately.
            </p>
          </div>
          <div className="col-12 col-xl-auto mt-3 mt-xl-0">
            <button className="btn btn-white">Log out all devices</button>
          </div>
        </div>
  
        <div className="card">
          <div className="card-body">
            <div className="list-group list-group-flush my-n3">
  
              <div className="list-group-item">
                <div className="row align-items-center">
                  <div className="col-auto">
                    <i className="fe fe-smartphone h1" />
                  </div>
                  <div className="col ms-n2">
                    <h4 className="mb-1">iPhone 11</h4>
                    <small className="text-body-secondary">Los Angeles, CA · 4/20/2020, 4:16 PM</small>
                  </div>
                  <div className="col-auto">
                    <button className="btn btn-sm btn-white">Log out</button>
                  </div>
                </div>
              </div>
  
              <div className="list-group-item">
                <div className="row align-items-center">
                  <div className="col-auto">
                    <i className="fe fe-monitor h1" />
                  </div>
                  <div className="col ms-n2">
                    <h4 className="mb-1">iMac OSX · Safari 10.2</h4>
                    <small className="text-body-secondary">Los Angeles, CA · 4/20/2020, 4:16 PM</small>
                  </div>
                  <div className="col-auto">
                    <button className="btn btn-sm btn-white">Log out</button>
                  </div>
                </div>
              </div>
  
              <div className="list-group-item">
                <div className="row align-items-center">
                  <div className="col-auto">
                    <i className="fe fe-smartphone h1" />
                  </div>
                  <div className="col ms-n2">
                    <h4 className="mb-1">iPhone 11</h4>
                    <small className="text-body-secondary">Los Angeles, CA · 4/20/2020, 4:16 PM</small>
                  </div>
                  <div className="col-auto">
                    <button className="btn btn-sm btn-white">Log out</button>
                  </div>
                </div>
              </div>
  
              <div className="list-group-item">
                <div className="row align-items-center">
                  <div className="col-auto">
                    <i className="fe fe-monitor h1" />
                  </div>
                  <div className="col ms-n2">
                    <h4 className="mb-1">iMac OSX · Safari 10.2</h4>
                    <small className="text-body-secondary">Los Angeles, CA · 4/20/2020, 4:16 PM</small>
                  </div>
                  <div className="col-auto">
                    <button className="btn btn-sm btn-white">Log out</button>
                  </div>
                </div>
              </div>
  
            </div>
          </div>
        </div>
      </div>
  
    </div>
  </div>
  
  );
};

export default Security;
